module.exports = __webpack_public_path__ + "static/Column-ff5d83b4fc2bd3a7ab0972759dc02699.png";